import AirTracker, { Config, Environment } from '@airwallex/airtracker';
import versionFile from '../version.json';
import { getPageEnvByHost } from './environment';

const pageEnv = getPageEnvByHost();

const config: Config = {
  appName: 'ext_billing_hosted_invoice',
  appVersion: versionFile.version,
  env: (pageEnv === 'sandbox' ? 'preview' : pageEnv) as Environment,
  enableErrorMonitoring: true,
  assetSpeedMonitoringWhiteList: [/\.airwallex\.com\//],
};

export const airTracker = new AirTracker({ config });
